import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { LabMDM } from "../masterdata/models/lab";
import { BBResponseContainer } from "../carrier/response-container";
import { Subject } from "rxjs";
import { MachineType } from "../masterdata/models/machineType";
import { LabProcessingRequest } from "./processing-request";
import { timeout, tap } from 'rxjs/operators';

/**
 * @description Angular Service to interact with Sample Reception service
 * to get a carrier status based on barcode and robot.
 */
@Injectable()
export class CarrierStatusService {


    constructor(private http: HttpClient) {
    }

    /**
     * @description Find by Carrier Status details for given barcode.
     * @param carrierBarcode 
     * @param selectedLab
    */
    searchByCarrierStatusByBarcode(carrierBarcode: string, lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'carrier/status';
        let requestParam = new HttpParams()
            .set('labId', lab._id)
            .set('carrierBarcode', carrierBarcode);
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Count by Carrier barcode.
     * @param carrierBarcode 
     * @param selectedLab
    */
    getCountByCarrierBarcode(carrierBarcode: string, lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'carrier/status/count';
        let requestParam = new HttpParams()
            .set('labId', lab._id)
            .set('carrierBarcode', carrierBarcode);
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Save by Carrier status.
     * @param processingRequest 
    */
    addCarrierStatus(processingRequest: LabProcessingRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'carrier/status'
        return this.http.post<BBResponseContainer>(url, processingRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    
    addCarrierStatusForPreparing(processingRequest: LabProcessingRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'preparingplate'
        return this.http.post<BBResponseContainer>(url, processingRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    /**
     * @description Get Machine List.
     */
    getMachineList(): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine';
        let requestParam = new HttpParams();
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Get Carrier State List.
     */
    getCarrierStateList(): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/carrier/state';
        let requestParam = new HttpParams();
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
         * @description get the Data for Progress Tracker
        */
    getProgressTrackerData(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'carrier/status/progress';
        let requestParam = new HttpParams()
            .set('labId', lab._id);
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Get Container list for given barcode.
     */
    getContainerListbyLab(): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine';
        let requestParam = new HttpParams();
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Function validates barcode exists in BB.
     */
    validateContainerBarcode(reactionContainerBarcode: string, lab: LabMDM):  Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'carrier/status/'+reactionContainerBarcode+'/'+lab._id;
        let requestParam = new HttpParams();
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

     /**
     * @description Function validates barcode exists in BB.
     */
    validateReactioMachineBarcode(reactionMachineBarcode: string, lab: LabMDM):  Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine/'+reactionMachineBarcode+'/'+lab._id;
        let requestParam = new HttpParams();
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    
   /**
     * @description Function validates barcode exists in BB.
     */
    validateMachineBarcode(reactionMachineBarcode: string, lab: LabMDM, machineType: MachineType):  Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine/'+reactionMachineBarcode+'/'+lab._id;
        let requestParam = new HttpParams().set('machineTypeId', machineType._id.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Function get CarrierState from BB.
     */
    getProcessStepDetails(carrierStateId: string, lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/carrier/state/definition';
        let requestParam = new HttpParams().set('processStep', carrierStateId.toString()).set('labId', lab._id);
    
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
          error.url = url;
        }));
    }


    //Gets a list of printers
    getPrintersList(lab: LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "admin/mdm/printer";
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of printers based on dynamic parameters
    getPrintersListWithTemplate(lab: LabMDM, active: boolean, labelTemplate: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "admin/mdm/printer";
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString())
                                           .set('labelTemplate', labelTemplate);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //shared Methods
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) {
        console.log("emit change");
        this.emitChangeSource.next(change);
    }
}